import { Flex, Text } from '@lego/klik-ui';
import { Navigate } from 'react-router-dom';
import { Loader, PageLoadError } from '@/components/common';
import { useDocumentTitle } from '@/hooks/common';
import { useWorkspaces } from '@/hooks/workspace';
import { paths } from '@/utility/global_paths';

export const LandingPage = () => {
  useDocumentTitle('Home');
  const { data, error, isLoading, mutate } = useWorkspaces();

  if (isLoading) {
    return (
      <Flex flexDirection="row" flexWrap="wrap" gap={4} justifyContent="center">
        <Loader />
      </Flex>
    );
  }

  if (error || !data) {
    return <PageLoadError onRetry={mutate} />;
  }

  if (data.workspaces.length === 0) {
    return (
      <Flex alignItems="center" flexDirection="column" gap={4} justifyContent="center">
        <Text>You don't have access to any workspaces</Text>
      </Flex>
    );
  }

  return data.workspaces.length > 1 ? (
    <Navigate replace to={paths.workspaces} />
  ) : (
    <Navigate replace to={paths.workspaceById(data.workspaces[0].id)} />
  );
};
